module.exports = __webpack_public_path__ + "static/dabanga-2-e4c6e60714f77126ffb3e9e80617b518.png";